<script setup lang="ts">
type MessageVariants = "info" | "success" | "error";

interface Props {
  variant?: MessageVariants;
  iconSize?: string;
}

withDefaults(defineProps<Props>(), {
  variant: "info",
  iconSize: "text-md",
});

interface IStyle {
  bgColor: string;
  icon: string;
}

const STYLES: Record<MessageVariants, IStyle> = {
  info: {
    bgColor: "bg-darkOcean100",
    icon: "fa-info-circle",
  },
  success: {
    bgColor: "bg-green-100",
    icon: "fa-check-circle",
  },
  error: {
    bgColor: "bg-red-100",
    icon: "fa-exclamation-triangle",
  },
};
</script>

<template>
  <div
    class="rounded-xl p-4 flex justify-between gap-4 items-center"
    :class="[STYLES[variant].bgColor]"
  >
    <i class="fas" :class="[STYLES[variant].icon, iconSize]"></i>
    <div class="flex-grow b300 text-neutral800">
      <slot></slot>
    </div>
  </div>
</template>
